import { motion } from "framer-motion";
import { Play } from "lucide-react";
import { VIDEO_THUMB } from "@/lib/constants";

export default function AmbassadorMessage({ onWatchClick }) {
  return (
    <section id="ambassador-message" data-testid="ambassador-message-section" className="bg-[#f7f2e8]">
      <div className="max-w-[1480px] mx-auto px-5 md:px-10 py-20 md:py-28 grid lg:grid-cols-[1fr_1.6fr] gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9 }}
        >
          <h2 className="font-serif-display text-4xl sm:text-5xl leading-[1.1] text-[#141414]">
            Experience the
            <br />
            Carlton Difference
          </h2>
          <p className="mt-6 text-[#4a4a4a] text-base md:text-lg max-w-md leading-relaxed">
            Discover how Carlton Wellness Center combines prevention, recovery, longevity,
            and lifestyle wellness into one premium, protocol-led experience designed for
            modern living.
          </p>
          <button
            onClick={onWatchClick}
            data-testid="watch-video-button"
            className="btn-gold mt-8"
          >
            <span className="w-5 h-5 rounded-full border border-[#050505]/60 flex items-center justify-center">
              <Play size={9} fill="currentColor" strokeWidth={0} />
            </span>
            Watch Our Story
          </button>
        </motion.div>

        <motion.button
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.2, 0.8, 0.2, 1] }}
          onClick={onWatchClick}
          data-testid="video-thumbnail"
          className="relative group rounded-2xl overflow-hidden shadow-2xl aspect-video w-full"
          aria-label="Play brand ambassador video"
        >
          <img
            src={VIDEO_THUMB}
            alt="Mrunal Thakur — Carlton Wellness Center video"
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
          />
          <span className="absolute inset-0 bg-black/15 group-hover:bg-black/5 transition-colors duration-500" />
          <span className="absolute inset-0 flex items-center justify-center">
            <span className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-white/95 flex items-center justify-center shadow-xl transition-transform duration-500 group-hover:scale-110">
              <Play size={26} className="text-[#3a2c12] ml-1" fill="currentColor" strokeWidth={0} />
            </span>
          </span>
        </motion.button>
      </div>
    </section>
  );
}
